import {Component, inject, OnInit, signal, ViewChild} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { Header } from './features/shared/header/header';
import { DrawerUtils } from './services/drawer-utils';
import {Navbar} from './features/shared/navbar/navbar';
import {AuthService} from './core/auth/auth-service';
import {MsalBroadcastService} from '@azure/msal-angular';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs';
import {InteractionStatus} from '@azure/msal-browser';
import {Spinner} from './features/shared/spinner/spinner';
import {MapLoader} from './services/map-loader';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, MatSidenavModule, MatListModule, MatIconModule, Navbar, Spinner],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  @ViewChild('drawer') drawer!: MatDrawer;

  public readonly authService = inject(AuthService);
  public readonly drawerUtils = inject(DrawerUtils);
  public readonly mapLoader = inject(MapLoader);

  protected readonly title = signal('apollo-web');

  ngOnInit(): void {
    this.mapLoader.init();
  }

  resetSignal() {
    if (this.drawerUtils.drawerState()) {
      this.drawerUtils.drawerState.set(false);
    }
  }
}
